var map = {
	"./Approved.svg": 3736,
	"./AwaitingParts.svg": 3737,
	"./Closed.svg": 3738,
	"./Completed.svg": 3739,
	"./Excel.svg": 3740,
	"./Exportall_grey.svg": 3741,
	"./Exportall_grey_circle.svg": 3742,
	"./InProgress.svg": 3743,
	"./New.svg": 3744,
	"./View_Pic_Grey.svg": 3745,
	"./accident.svg": 3746,
	"./account.svg": 3747,
	"./addOrange.svg": 3748,
	"./addUser.svg": 3749,
	"./addVehicle.svg": 3750,
	"./address.svg": 3751,
	"./alert.svg": 3752,
	"./all_active.svg": 3753,
	"./all_active_es.svg": 3754,
	"./arrow-down.svg": 3755,
	"./arrow-up.svg": 3756,
	"./arrowRight.svg": 3757,
	"./awaiting_parts_grey.svg": 3758,
	"./awaiting_parts_orange.svg": 3759,
	"./back-btn.svg": 3760,
	"./back-button-grey.svg": 3761,
	"./backButton.svg": 3762,
	"./bills_of_landing_active.svg": 3763,
	"./bills_of_landing_active_es.svg": 3764,
	"./bobTail.svg": 3765,
	"./book-solid.svg": 3766,
	"./boxTruck.svg": 3767,
	"./calanderIcon.svg": 3768,
	"./cameraSelected.svg": 3769,
	"./camera_selected.svg": 3770,
	"./chat-icon.svg": 3771,
	"./circle-Exportall_grey.svg": 3772,
	"./circle-export.svg": 3773,
	"./circle-exportUser.svg": 3774,
	"./circle-import.svg": 3775,
	"./circle-importUser.svg": 3776,
	"./circle-viewall.svg": 3777,
	"./clearAll.svg": 3778,
	"./close-popup.svg": 3779,
	"./closeMap.svg": 3780,
	"./closed-Orange.svg": 3781,
	"./closed-grey.svg": 3782,
	"./clusterIcon.svg": 3783,
	"./communication_records_active.svg": 3784,
	"./communication_records_active_es.svg": 3785,
	"./company.svg": 3786,
	"./companyIcon.svg": 3787,
	"./complete-Orange.svg": 3788,
	"./complete-grey.svg": 3789,
	"./csa.svg": 3790,
	"./csaSnapshot.svg": 3791,
	"./dailyDocuments.svg": 3792,
	"./dashboard.svg": 3793,
	"./dashboardIcon.svg": 3794,
	"./date.svg": 3795,
	"./delete.svg": 3796,
	"./deleteCircle.svg": 3797,
	"./delivery_receipts_active.svg": 3798,
	"./delivery_receipts_active_es.svg": 3799,
	"./departments.svg": 3800,
	"./departmetEdit.svg": 3801,
	"./developer.svg": 3802,
	"./direction.svg": 3803,
	"./dispatch_records_active.svg": 3804,
	"./dispatch_records_active_es.svg": 3805,
	"./document.svg": 3806,
	"./documents.svg": 3807,
	"./dot.svg": 3808,
	"./dotAudit.svg": 3809,
	"./dotauditIcon.svg": 3810,
	"./downarrowIcon.svg": 3811,
	"./download.svg": 3812,
	"./downloadCenter.svg": 3813,
	"./downloadCenterMenu.svg": 3814,
	"./driver-behaviour.svg": 3815,
	"./driver.svg": 3816,
	"./dryVan.svg": 3817,
	"./dtc.svg": 3818,
	"./dualCam.svg": 3819,
	"./dump.svg": 3820,
	"./edit.svg": 3821,
	"./editLogIcon.svg": 3822,
	"./editSvg.svg": 3823,
	"./en.svg": 3824,
	"./es.svg": 3825,
	"./excelNew.svg": 3826,
	"./export-grey.svg": 3827,
	"./export.svg": 3828,
	"./exportUser.svg": 3829,
	"./feedback.svg": 3830,
	"./file-pdf-regular.svg": 3831,
	"./filter.svg": 3832,
	"./flatBed.svg": 3833,
	"./fleet.svg": 3834,
	"./fleetCompanies.svg": 3835,
	"./fleetdriverIcon.svg": 3836,
	"./fleetvehiclesIcon.svg": 3837,
	"./fletBed.svg": 3838,
	"./fuel.svg": 3839,
	"./full.svg": 3840,
	"./hamburger.svg": 3841,
	"./help-icon.svg": 3842,
	"./historyLogs.svg": 3843,
	"./icon-delete.svg": 3844,
	"./icon-export.svg": 3845,
	"./icon-menu-logs.svg": 3846,
	"./ifta.svg": 3847,
	"./import.svg": 3848,
	"./importUser.svg": 3849,
	"./in_progress_grey.svg": 3850,
	"./in_progress_orange.svg": 3851,
	"./infoTruck.svg": 3852,
	"./inspection-dvir.svg": 3853,
	"./inspection.svg": 3854,
	"./key.svg": 3855,
	"./leftArrow.svg": 3856,
	"./location.svg": 3857,
	"./locationMap.svg": 3858,
	"./log.svg": 3859,
	"./logEdit.svg": 3860,
	"./logHistory.svg": 3861,
	"./logoutIcon.svg": 3862,
	"./logs.svg": 3863,
	"./logsIcon.svg": 3864,
	"./mack.svg": 3865,
	"./mail.svg": 3866,
	"./main_camera.svg": 3867,
	"./mappinPopup.svg": 3868,
	"./menu_companies.svg": 3869,
	"./menu_dailyLog.svg": 3870,
	"./menu_reports.svg": 3871,
	"./menu_reseller.svg": 3872,
	"./menu_vehicle.svg": 3873,
	"./messageSender.svg": 3874,
	"./messaging.svg": 3875,
	"./new_login.svg": 3876,
	"./ninePin.svg": 3877,
	"./nonEdit.svg": 3878,
	"./notFull.svg": 3879,
	"./not_started_grey.svg": 3880,
	"./not_started_orange.svg": 3881,
	"./otherTrailer.svg": 3882,
	"./otherTruck.svg": 3883,
	"./other_documents_active.svg": 3884,
	"./other_documents_active_es.svg": 3885,
	"./overview.svg": 3886,
	"./page-first.svg": 3887,
	"./page-last.svg": 3888,
	"./page-next.svg": 3889,
	"./page-prev.svg": 3890,
	"./phone.svg": 3891,
	"./pickup.svg": 3892,
	"./pneumaticTrailer.svg": 3893,
	"./policy.svg": 3894,
	"./popupClose.svg": 3895,
	"./popupConfirm.svg": 3896,
	"./popupDelete.svg": 3897,
	"./privatePassenger.svg": 3898,
	"./qbdii.svg": 3899,
	"./receipts_active.svg": 3900,
	"./receipts_active_es.svg": 3901,
	"./reeferTrailer.svg": 3902,
	"./refreshCircle.svg": 3903,
	"./renewal.svg": 3904,
	"./repair.svg": 3905,
	"./reportIcon.svg": 3906,
	"./reports.svg": 3907,
	"./save-regular.svg": 3908,
	"./scoreCard.svg": 3909,
	"./searchGrey.svg": 3910,
	"./selectedConnection.svg": 3911,
	"./share.svg": 3912,
	"./sixPin.svg": 3913,
	"./sort.svg": 3914,
	"./speedometer.svg": 3915,
	"./spotlightGreen.svg": 3916,
	"./spotlightGrey.svg": 3917,
	"./spotlightRed.svg": 3918,
	"./straightTruck.svg": 3919,
	"./supportIcon.svg": 3920,
	"./switch.svg": 3921,
	"./tankerTrailer.svg": 3922,
	"./tick.svg": 3923,
	"./time.svg": 3924,
	"./timePicker.svg": 3925,
	"./toggle-off.svg": 3926,
	"./toggle-on.svg": 3927,
	"./tools.svg": 3928,
	"./tractorDayCab.svg": 3929,
	"./tractorSleeper.svg": 3930,
	"./undelete.svg": 3931,
	"./unsaved.svg": 3932,
	"./update.svg": 3933,
	"./upload.svg": 3934,
	"./usdot.svg": 3935,
	"./user.svg": 3936,
	"./userprofileIcon.svg": 3937,
	"./users.svg": 3938,
	"./vacuumTrailer.svg": 3939,
	"./vacuumTruck.svg": 3940,
	"./van.svg": 3941,
	"./vehicle-behaviour.svg": 3942,
	"./vehicle.svg": 3943,
	"./vehicleIcon.svg": 3944,
	"./viewArrow.svg": 3945,
	"./viewDocument.svg": 3946,
	"./viewReports.svg": 3947,
	"./viewStatus.svg": 3948,
	"./viewallMap.svg": 3949,
	"./violation.svg": 3950,
	"./volvo.svg": 3951,
	"./weigh_tickets_active.svg": 3952,
	"./weigh_tickets_active_es.svg": 3953,
	"./whitecheck_new.svg": 3954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3735;